// extracted by css-extract-rspack-plugin
export default {"table":"V0TVa","headerCell":"paGh7","footer":"p7HQd"};